import api from './api';

export const updateTheme              = (theme)    => api.put('/api/users/me/theme', { theme });
export const updateProfile            = (data)     => api.put('/api/users/me/profile', data);
export const updateCalendarPreference = (calendar) => api.put('/api/users/me/calendar', { calendar });
